import { batch } from 'react-redux';
import { actions as groupActions } from '@ff-scene-plugins/photo-prints-redux/slices/groupsSlice';
import { actions as groupUiActions } from '@ff-scene-plugins/photo-prints-redux/slices/groupsUiSlice';
import { PhotoPrintsPdpThunk } from '@ff-scene-plugins/photo-prints-redux/store';
import { PhotoPrintsJson } from '@ff-scene-plugins/photo-prints-shared/PhotoPrintsJson';
import { updateWithScheduledReset } from './withScheduledReset';

export const addGroup = (group: PhotoPrintsJson.Group): PhotoPrintsPdpThunk => {
    const groupId = group.id;
    return dispatch => batch(() => {
        dispatch(groupActions.add(group));
        dispatch(groupUiActions.add({ id: groupId }));
        dispatch(updateWithScheduledReset({ id: groupId, key: 'isNewGroup', value: true }));
    });
};